var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../app2/Components/ComponentModal';
import Message from '../../app2/ComponentMessage';
import userHasPartner from '../../app2/Utils/UserHasPartner';
import AuthenticationModal from '../../app2/store/components/AuthenticationModal';
import LawdocsIframe from './LawdocsIframe';
import axios from 'axios';
import T from '../../app2/Utils/Locale';
import './index.css';
const debug = false;
const verbose = false;
const isProductionEnvironment = process.env.NODE_ENV === 'production';
const LawdocsFlow = ({ endpoint, type, user = false, purchase_type = '' }) => {
    const [showLoading, toggleShowLoading] = useState(true);
    const [message, setMessage] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const [isAuthenticationModalVisible, setAuthenticationModalVisible] = useState(false);
    const [isUserAuthenticated, setUserAuthenticated] = useState(false);
    const instance = useRef();
    /**
     * When the user has authenticated through the SaveModal (which are only displayed for unauthenticated users), notify
     * LawDocs to make it re-run the finished progress.
     */
    useEffect(() => {
        if (isUserAuthenticated) {
            instance.current.addSetting('is_authenticated', true);
            instance.current.notifyObservers('DRAFT_SAVE_FINISHED');
            instance.current.addObserver((event, parameters) => {
                const [, document] = parameters;
                window.location.href = `/my-documents/sign-redirect/${document._id}?purchaseType=true`;
            });
        }
    }, [isUserAuthenticated]);
    useEffect(() => {
        instance.current.addSetting('push_state_url', `/opret-dokument/${type}`);
        instance.current.addSetting('document_type', type);
        instance.current.addSetting('debug_mode', !isProductionEnvironment && debug);
        instance.current.addSetting('verbose_mode', !isProductionEnvironment && verbose);
        instance.current.addSetting('draft', true);
        instance.current.addSetting('is_authenticated', false);
        if (user) {
            instance.current.addSetting('person_1_name', user.fullname);
            instance.current.addSetting('person_1_email', user.email);
            instance.current.addSetting('person_1_address', user.address);
            instance.current.addSetting('person_1_postal', user.postal);
            instance.current.addSetting('person_1_city', user.city);
            instance.current.addSetting('is_authenticated', true);
            instance.current.addSetting('is_lo_member', userHasPartner(user, 'lo'));
            if (user.ssn) {
                instance.current.addSetting('person_1_cpr', user.ssn);
            }
        }
        instance.current.addObserver((event, parameters) => __awaiter(void 0, void 0, void 0, function* () {
            if (event === 'DRAFT_LOAD') {
                const [documentId] = parameters;
                let document, history;
                try {
                    const response = yield axios.get(`/lawdocs/load/${documentId}`, { withCredentials: true });
                    document = response.data.document;
                    history = response.data.history;
                }
                catch (error) {
                    if (!error.response || error.response.status !== 401) {
                        setMessage({ content: T('errors.failed_to_load_document'), severity: 'error' });
                    }
                }
                instance.current.notifyObservers('DRAFT_LOADED', document, history);
            }
            if (event === 'DRAFT_SAVE') {
                const [document, stepHistory, isCompleted] = parameters;
                try {
                    const saveResponse = yield axios.post('/lawdocs/save', {
                        type,
                        purchase_type: purchase_type,
                        document_id: document._id,
                        document: JSON.stringify(document),
                        history: JSON.stringify(stepHistory),
                        complete: isCompleted
                    }, {
                        withCredentials: true,
                        validateStatus: function (status) {
                            return status === 200; // Only accept HTTP 200 on the save endpoint. Anything else should throw errors.
                        }
                    });
                    if (!saveResponse.data.includes(document._id)) {
                        console.error('Lawdocs/save response did not reflect document ID.');
                        setMessage({ content: T('errors.failed_to_save_document'), severity: 'error' });
                        return;
                    }
                }
                catch (error) {
                    setMessage({ content: T('errors.failed_to_save_document'), severity: 'error' });
                    return;
                }
                instance.current.notifyObservers('DRAFT_SAVED');
            }
            if (event === 'APP_LOADED') {
                toggleShowLoading(false);
            }
            if (event === 'INFOBOX_SHOW') {
                const [, content] = parameters;
                setModalContent(content);
                window.jQuery('#lock_modal_cancel').on('click', () => {
                    setModalContent(false);
                });
                window.jQuery('#lock_modal_ok').on('click', () => {
                    setModalContent(false);
                    instance.current.notifyObservers('GO_TO_STEP_NEXT');
                });
            }
            if (event === 'VARIABLE') {
                const [name, percentage] = parameters;
                if (name === 'totalPercentage') {
                    if (percentage) {
                        window.jQuery('.header-score-bar').show();
                        window.jQuery('.header-score-bar__progress').css('width', `${percentage}%`);
                        window.jQuery('.header-score-bar__text span').text(percentage);
                    }
                    else {
                        window.jQuery('.header-score-bar').hide();
                    }
                }
            }
            if (event === 'APP_FINISHED') {
                const [document] = parameters;
                if (user) {
                    window.location.href = `/my-documents/sign-redirect/${document._id}?purchaseType=true`;
                }
                else {
                    setAuthenticationModalVisible(true);
                }
            }
            if (event === 'MESSAGE') {
                const [content, severity] = parameters;
                setMessage({ content, severity });
            }
            if (event === 'STEP_NEXT') {
                window.jQuery('.header-score-bar').hide();
                setMessage(false);
            }
        }));
    }, []);
    return (_jsxs("div", { children: [showLoading && (_jsxs("div", Object.assign({ className: 'loading-testaviva' }, { children: [_jsx("div", { className: 'loading-testaviva-overlay' }), _jsx("div", { className: 'loading-testaviva-logo' })] }))), isAuthenticationModalVisible ? (_jsx(AuthenticationModal, { onClose: () => setAuthenticationModalVisible(false), onCreate: () => setUserAuthenticated(true) })) : null, modalContent !== false && (_jsx(Modal, Object.assign({ closeModal: () => setModalContent(false), isWide: true, id: 'modal-content' }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: modalContent } }) }))), message !== false && (_jsx(Message, { message: message.content, isSuccessful: message.severity === 'success' })), _jsx(LawdocsIframe, { ref: instance, type: type, endpoint: endpoint })] }));
};
LawdocsFlow.propTypes = {
    type: PropTypes.string.isRequired,
    purchase_type: PropTypes.string,
    user: PropTypes.shape({
        fullname: PropTypes.string,
        email: PropTypes.string,
        address: PropTypes.string,
        postal: PropTypes.string,
        city: PropTypes.string,
        ssn: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool
        ])
    })
};
export default LawdocsFlow;
